module.exports = {
  API_ENDPOINT: "https://api.eventupp.pt",
  IMG_ENDPOINT: "https://api.eventupp.pt",
  WEB_ENDPOINT: "https://eventupp.pt",
};
